import { connect } from 'react-redux'
import App from "../components/App";
import {
    addScriptTag,
    booleanChange,
    createProductWebhooks,
    createStoreJs,
    deleteProductWebhooks,
    dismissToast,
    generatePartnerLink, genSettingsBooleanChange,
    hardRefresh,
    installScripts,
    moneyCssClassChange,
    numberChange,
    onShopNameChanged,
    openSendReviewRequest, packageChange,
    partnerEmailChange,
    removeScriptTag,
    reviewRequestEmailChange, saveNumber,
    searchShop,
    sendReviewRequest,
    submitSettings,
    toggleAttributes, updateDiscountVersionChange, wakeUpAriel, widgetDevChange, widgetVersionChange
} from "../actions/main";

const mapStateToProps = state => ({
    shopName: state.main.shopName,
    searching: state.main.searching,
    searchError: state.main.searchError,
    error: state.main.error,
    adminLink: state.main.adminLink,
    bundlesAdminLink: state.main.bundlesAdminLink,
    attributes: state.main.attributes,
    showAttributes: state.main.showAttributes,
    booleans: state.main.booleans,
    boolProcessing: state.main.boolProcessing,
    gettingAllStores: state.main.gettingAllStores,
    stores: state.main.stores,
    modifiableBooleans: state.main.modifiableBooleans,
    modifiableStrings: state.main.modifiableStrings,
    resyncing: state.main.resyncing,
    installingScripts: state.main.installingScripts,
    toastIsActive: state.main.toastIsActive,
    toastContent: state.main.toastContent,
    addingScriptTag: state.main.addingScriptTag,
    removingScriptTag: state.main.removingScriptTag,
    creatingStoreJs: state.main.creatingStoreJs,
    generalSettings: state.main.generalSettings,
    billing: state.main.billing,
    isSubmitting: state.main.isSubmitting,
    showReviewRequestEmail: state.main.showReviewRequestEmail,
    reviewRequestEmail: state.main.reviewRequestEmail,
    sendingReviewRequest: state.main.sendingReviewRequest,
    partnerEmail: state.main.partnerEmail,
    modifiableNumbers: state.main.modifiableNumbers,
    numberProcessing: state.main.numberProcessing,
    numberError: state.main.numberError,
    packages: state.main.packages,
    packageChanging: state.main.packageChanging,
    main: state.main,
});

const mapDispatchToProps = dispatch => ({
    onShopNameChanged: text => dispatch(onShopNameChanged(text)),
    onMoneyCssClassChange: text => dispatch(moneyCssClassChange(text)),
    onReviewRequestEmailChange: text => dispatch(reviewRequestEmailChange(text)),
    onPartnerEmailChange: text => dispatch(partnerEmailChange(text)),
    onPackageChange: id => dispatch(packageChange(id)),
    onSearch: () => dispatch(searchShop()),
    submitSettings: () => dispatch(submitSettings()),
    toggleAttributes: () => dispatch(toggleAttributes()),
    deleteProductWebhooks: () => dispatch(deleteProductWebhooks()),
    createProductWebhooks: () => dispatch(createProductWebhooks()),
    hardRefresh: () => dispatch(hardRefresh()),
    installScripts: () => dispatch(installScripts()),
    addScriptTag: () => dispatch(addScriptTag()),
    removeScriptTag: () => dispatch(removeScriptTag()),
    createStoreJs: () => dispatch(createStoreJs()),
    sendReviewRequest: () => dispatch(sendReviewRequest()),
    onDismissToast: () => dispatch(dismissToast()),
    openSendReviewRequest: () => dispatch(openSendReviewRequest()),
    wakeUpAriel: () => dispatch(wakeUpAriel()),
    generatePartnerLink: () => dispatch(generatePartnerLink()),
    onBooleanChange: key => bool => dispatch(booleanChange(key, bool)),
    onGenSettingBoolChange: key => bool => dispatch(genSettingsBooleanChange(key, bool)),
    onNumberChange: key => number => dispatch(numberChange(key, number)),
    onSaveNumber: key => () => dispatch(saveNumber(key)),
    onWidgetVersionChange: text => dispatch(widgetVersionChange(text)),
    onWidgetDevChange: text => dispatch(widgetDevChange(text)),
    onUpdateDiscountVersionChange: text => dispatch(updateDiscountVersionChange(text)),
});


export default connect(mapStateToProps, mapDispatchToProps)(App)
